module.exports = function() {
  return new Worker(__webpack_public_path__ + "d0268fda84b1b66b74aa.worker.js");
};